import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { alertMessageState } from "src/atom/LoadingState";
import Paginator from "src/components/Paginator";
import callApi from "src/services/Common/api";
import { loadingState } from "src/atom/LoadingState";
import { authState } from "src/atom/authState";

export default function ScrutinyCandidates() {
  const searchObject = {
    size: 10,
    totalPages: 0,
    totalItems: 0,
    sortWith: "id",
    currentPage: 1,
    sortOrder: "asc",
    candidateName: "",
    status: "NOT STARTED",
    registrationNumber: "",
  };

  const [formData, setFormData] = useState(searchObject);
  const navigate = useNavigate();
  const enableLoader = useSetRecoilState(loadingState);
  const [candidates, setCandidates] = useState([]);
  const [advertisement, setAdvertisemnt] = useState([]);
  const setAlertMessage = useSetRecoilState(alertMessageState);
  const [auth, setAuth] = useRecoilState(authState);

  const handleClear = (e) => {
    e.preventDefault();
    console.log("Before reset:", formData);
    setFormData({ ...searchObject });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleAdvtChange = (e) => {
    const { name, value } = e.target;
    if (value) {
      fetchDataApiCall(value);
    }
  };

  useEffect(() => {
    fetchAdvertismentsApiCall();
    fetchDataApiCall(2);
  }, []);

  useEffect(() => {
    fetchDataApiCall(2);
  }, [formData?.currentPage, formData?.size, formData?.status]);

  const fetchDataApiCall = async (pageId) => {
    var url = `/v1/api/scrutiny-dashboard/${pageId}`;
    const responseData = await callApi(
      url,
      "POST",
      formData,
      true,
      setAlertMessage
    );
    if (responseData.success !== false) {
      if (responseData.body && Object.keys(responseData.body).length > 0) {
        setCandidates(responseData.body.candidates);
        setFormData((previousData) => ({
          ...previousData,
          currentPage: +responseData?.body?.currentPage,
          size: +responseData?.body?.size,
          totalPages: +responseData?.body?.totalPages,
          totalItems: +responseData?.body?.totalItems,
          next: +responseData?.body?.currentPage + 1,
          prev: +responseData?.body?.currentPage - 1,
        }));
      }
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchDataApiCall(2);
  };

  const handleView = (e, candidate) => {
    e.preventDefault();
    navigate("/view-application", {
      state: {
        id: candidate?.id,
        pageId: 2,
        status: candidate?.status,
        candidates: candidates,
      },
    });
  };

  const nextPage = (pageNumber) => {
    setFormData((previousData) => ({
      ...previousData,
      currentPage: pageNumber,
    }));
  };

  const fetchAdvertismentsApiCall = async () => {
    enableLoader(true);
    const responseData = await callApi(
      `/v1/api/all-advertisements`,
      "GET",
      null,
      true,
      setAlertMessage
    );
    if (responseData.success != false) {
      setAdvertisemnt(responseData.body);
    }
    enableLoader(false);
  };

  return (
    <>
      <div className="card">
        <div
          className="card-header text-white"
          style={{ backgroundColor: "#3C4B64" }}
        >
          Scrutiny Candidates
        </div>
        <div className="card-body">
          <div className="mb-3">
            <form>
              <div className="row">
                {(auth?.role == "ADMIN" || auth.role == "SUPERADMIN") && (
                  <div className="col">
                    <label className="ms-2">
                      <b>Advertisement</b>
                    </label>
                    <select
                      id="advertisement"
                      className="form-control"
                      name="advertisement"
                      onChange={handleAdvtChange}
                    >
                      <option value="2">TGT</option>
                      {/* {advertisement?.map((advt) => (
                      <option key={advt.id} value={advt.id}>
                        {advt.advertisementName}
                      </option>
                    ))} */}
                    </select>
                  </div>
                )}
                <div className="col">
                  <label className="ms-2">
                    <b>Registration Number</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Registration No."
                    name="registrationNumber"
                    value={formData?.registerationNumber}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col">
                  <label className="ms-2">
                    <b>Candidate Name</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Candidate Name"
                    name="candidateName"
                    value={formData?.candidateName}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col">
                  <label className="ms-2">
                    <b>Status</b>
                  </label>
                  <select
                    id="inputState"
                    className="form-control"
                    name="status"
                    value={formData?.status}
                    onChange={handleInputChange}
                  >
                    <option value="">All</option>
                    <option value="NOT STARTED">NOT STARTED</option>
                    <option value="VERIFIED">COMPLETED</option>
                  </select>
                </div>
                <div className="col mt-4">
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    className="btn btn-warning ms-3 text-white"
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </form>
          </div>
          <table className="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Registration No.</th>
                <th>Candidate Name</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {candidates?.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">
                    No candidate found
                  </td>
                </tr>
              ) : (
                candidates.map((candidate, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{candidate?.registrationNumber}</td>
                    <td>{candidate?.candidateName}</td>
                    <td>{candidate?.status}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-success btn-fill text-white"
                        onClick={(e) => {
                          handleView(e, candidate);
                        }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="row">
        <div className="col-12 d-flex justify-content-center">
          <Paginator
            pagination={formData}
            range={3}
            nextPage={nextPage}
            setPagination={setFormData}
          />
        </div>
      </div>
    </>
  );
}
